import type { ReactNode } from 'react';

import { Card, CardContent, cn } from '@shigo-ui/ui';

import { dashboardPageTitleClassName } from './DashboardTypography.styles';
import { DashboardPageFormSecondaryRow } from './DashboardPageFormSecondaryRow';

export interface DashboardPageFormShellProps {
  title: ReactNode;
  subtitle?: ReactNode | undefined;
  backAction?: ReactNode | undefined;
  headerActions?: ReactNode | undefined;
  secondaryRow?: ReactNode | undefined;
  secondaryRowActions?: ReactNode | undefined;
  children: ReactNode;
  className?: string | undefined;
  contentClassName?: string | undefined;
  contentSurface?: 'card' | 'plain' | undefined;
}

export function DashboardPageFormShell({
  title,
  subtitle,
  backAction,
  headerActions,
  secondaryRow,
  secondaryRowActions,
  children,
  className,
  contentClassName,
  contentSurface = 'card',
}: DashboardPageFormShellProps) {
  return (
    <main className="bg-background min-h-0 flex-1 overflow-x-hidden overflow-y-auto px-4 pt-4 pb-0 md:px-6 md:pt-6">
      <section
        className={cn(
          'mx-auto flex min-h-full w-full max-w-[1920px] min-w-0 flex-col gap-6',
          className,
        )}
      >
        <header className="flex min-w-0 flex-wrap items-center gap-3">
          {backAction}
          <div className="min-w-0">
            <h1 className={dashboardPageTitleClassName('min-w-0')}>{title}</h1>
            {subtitle ? <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p> : null}
          </div>
          {headerActions ? (
            <div className="ml-auto flex items-center gap-2">{headerActions}</div>
          ) : null}
        </header>

        {secondaryRow != null || secondaryRowActions != null ? (
          <DashboardPageFormSecondaryRow actions={secondaryRowActions}>
            {secondaryRow}
          </DashboardPageFormSecondaryRow>
        ) : null}

        {contentSurface === 'plain' ? (
          <div className={cn('min-w-0', contentClassName)}>{children}</div>
        ) : (
          <Card className="border-border bg-card flex min-w-0 flex-1 flex-col overflow-clip rounded-md">
            <CardContent
              className={cn(
                'flex min-w-0 flex-1 flex-col p-0 [&>form]:flex [&>form]:flex-1 [&>form]:flex-col',
                contentClassName,
              )}
            >
              {children}
            </CardContent>
          </Card>
        )}
      </section>
    </main>
  );
}
